import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Menu from "../main/Menu";
import Header from "../main/Header";
import { axiosClient } from "../../helpers/axios";

const MiddlewareAuth = ({ children }) => {
  const auth = useSelector((state) => state.Login.auth);
  const token = auth?.token; // o desde localStorage

  useEffect(() => {
    const requestInterceptor = axiosClient.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      }
    );

    const responseInterceptor = axiosClient.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          // aquí luego puedes disparar logout
          // dispatch(resetAuth())
        }
        return Promise.reject(error);
      }
    );

    // cleanup 🔥
    return () => {
      axiosClient.interceptors.request.eject(requestInterceptor);
      axiosClient.interceptors.response.eject(responseInterceptor);
    };
  }, [token]);

  if (!auth?.isAuth) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Header />
      <div className="flex h-[calc(100vh-4rem)]">
        <Menu />

        {/* Content */}
        <main className="flex-1 overflow-auto bg-cs-bg p-2">
          {children}
        </main>
      </div>
    </>
  );
};

export default MiddlewareAuth;
